import React, { useState } from 'react';
import { ClearOutlined } from '@ant-design/icons';
import InputTextField from '@components/common/form/InputTextField';
import ListPage from '@components/common/layout/ListPage';
import { DEFAULT_TABLE_ITEM_SIZE_LARGE } from '@constants';
import apiConfig from '@constants/apiConfig';
import useListBase from '@hooks/useListBase';
import useTranslate from '@hooks/useTranslate';
import { BaseTable, TextField } from '@itz/react-cms-element';
import { commonMessage } from '@locales/intl';
import { IconSearch } from '@tabler/icons-react';
import { formatMoney } from '@utils';
import { Button, Col, Flex, Form, Row } from 'antd';

const IngredientModal = ({
    loading,
    dataList,
    currentRestaurant,
    beilageDataSelected,
    handleSelectBeilage,
    getDataList,
}) => {
    const translate = useTranslate();
    const restaurantDetail = currentRestaurant || {};

    const [searchValues, setSearchValues] = useState({ name: '', plu: '' });
    const [form] = Form.useForm();

    const handleSearch = () => {
        setPagination((prev) => ({ ...prev, current: 1 }));
        mixinFuncs.getList();
    };

    const handleCancelSearch = () => {
        form.resetFields();
        setPagination((prev) => ({ ...prev, current: 1 }));
        mixinFuncs.getList();
    };

    const {
        data,
        mixinFuncs,
        queryFilter,
        pagination,
        setPagination,
    } = useListBase({
        apiConfig: apiConfig.ingredients,
        options: {
            pageSize: DEFAULT_TABLE_ITEM_SIZE_LARGE,
        },
        override: (funcs) => {
            funcs.mappingData = (response) => {
                if (response.result === true) {
                    return {
                        data: response.data.content,
                        total: response.data.totalElements,
                    };
                }
            };
            funcs.changePagination = (page) => {
                setPagination((p) => {
                    const nextPagination = { ...p, current: page.current };

                    const formValues = form.getFieldsValue();
                    const params = {
                        ...formValues,
                        page: page.current - 1 >= 0 ? page.current - 1 : 0,
                        size: DEFAULT_TABLE_ITEM_SIZE_LARGE,
                        restaurantId: restaurantDetail?.id,
                    };

                    funcs.handleFetchList(params, true);

                    return nextPagination;
                });
            };
            funcs.prepareGetListParams = () => {
                const formValues = form.getFieldsValue();
                const currentPage = parseInt(queryFilter.page) || pagination.current;
                const params = {
                    ...formValues,
                    page: currentPage - 1 >= 0 ? currentPage - 1 : 0,
                    size: DEFAULT_TABLE_ITEM_SIZE_LARGE,
                    restaurantId: restaurantDetail?.id,
                };
                return params;
            };
        },
    });

    const columns = [
        { title: translate.formatMessage(commonMessage.plu), dataIndex: 'plu', width: '120px' },
        { title: translate.formatMessage(commonMessage.name), dataIndex: 'foodConditionName' },
        {
            title: translate.formatMessage(commonMessage.price),
            dataIndex: 'foodConditionPrice',
            render: (value) => formatMoney(value, JSON.parse(restaurantDetail?.settings)),
            width: '150px',
        },
        {
            title: translate.formatMessage(commonMessage.action),
            className: 'text-center',
            width: '120px',
            render: (dataRow) => (
                <Button
                    type="primary"
                    size="small"
                    onClick={() => handleSelectBeilage(dataRow)}
                    disabled={beilageDataSelected.some((bei) => bei.id === dataRow.id)}
                >
                    {translate.formatMessage(commonMessage.select)}
                </Button>
            ),
        },
    ];

    return (
        <div>
            <ListPage
                style={{ border: 'none' }}
                searchForm={
                    <>
                        <Form form={form} initialValues={{ phone: '', email: '' }}>
                            <Row gutter={10}>
                                <Col span={5}>
                                    <TextField
                                        name="name"
                                        placeholder={translate.formatMessage(commonMessage.name)}
                                        fieldProps={{
                                            onChange: (e) => {
                                                setSearchValues({
                                                    ...searchValues,
                                                    name: e.target.value,
                                                });
                                            },
                                        }}
                                    />
                                </Col>
                                <Col span={5}>
                                    <InputTextField
                                        name="plu"
                                        placeholder={translate.formatMessage(commonMessage.plu)}
                                        fieldProps={{
                                            onChange: (e) => {
                                                setSearchValues({
                                                    ...searchValues,
                                                    plu: e.target.value,
                                                });
                                            },
                                        }}
                                    />
                                </Col>
                                <Col span={8}>
                                    <Flex gap="10px">
                                        <Button type="primary" onClick={handleSearch}>
                                            <IconSearch style={{ width: '18px', height: '18px' }} />
                                            {translate.formatMessage(commonMessage.search)}
                                        </Button>
                                        <Button onClick={handleCancelSearch}>
                                            <ClearOutlined style={{ width: '18px', height: '18px' }} />
                                            {translate.formatMessage(commonMessage.clear)}
                                        </Button>
                                    </Flex>
                                </Col>
                            </Row>
                        </Form>
                    </>
                }
                baseTable={
                    <BaseTable
                        loading={loading}
                        columns={columns}
                        rowKey={(record) => record.id}
                        dataSource={data}
                        pagination={pagination}
                        onChange={mixinFuncs.changePagination}
                    />
                }
            />
        </div>
    );
};

export default IngredientModal;